import { useTranslation } from "react-i18next";

import { AXON_SITE_URL, APPS_MANIFEST_URL } from "../constants";

interface Props {
  filtered: number;
  total: number;
}

export function StatusBar({ filtered, total }: Props) {
  const { t } = useTranslation("common");

  return (
    <footer
      role="contentinfo"
      className="h-status px-3 flex items-center gap-2 bg-surface-subtle/50 border-t border-border-subtle shrink-0 font-mono text-11 leading-4 font-bold text-text-muted"
    >
      <span>{APPS_MANIFEST_URL}</span>
      <span aria-hidden="true" className="text-text-muted/50">·</span>
      <span>{t("status.counts", { filtered, total })}</span>
      <span className="flex-1" />
      <a
        href={AXON_SITE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="text-10 font-normal text-text-muted/60 transition-colors duration-150 hover:text-brand-primary"
      >
        {t("status.powered")}
      </a>
    </footer>
  );
}
